<template>
  <div class="main-hader">
    <header-left class="item"></header-left>
    <header-content class="items"></header-content>
    <header-right class="item"></header-right>
  </div>
</template>

<script>
import HeaderLeft from './main_header/HeaderLeft'
import HeaderContent from './main_header/HeaderContent'
import HeaderRight from './main_header/HeaderRight'
export default {
  name:"MainHeader",
  components:{
    HeaderLeft,
    HeaderContent,
    HeaderRight
  }
}
</script>

<style lang="less">
.main-hader{
  width: 100% ;
  height: 70%;
  padding: 1.25rem;
  display: flex;
  justify-content: space-around;
  .item{
    width: 25%;
  }
  .items{
    width: 37%;
  }
}
</style>